module.exports = __webpack_public_path__ + "static/media/cesped_otoño_corto.eddd110c.jpg";